
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/game",
      function () {
        return require("private-next-pages/battle-demo/game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/game"])
      });
    }
  